import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environment';
import { Driver, DriverFromPassengerProfilePayload, DriverPayload } from '../models/driver.model';
import { normalizeApiArray } from '../utils/api-response.util';

export interface DriverListFilter {
  organisationId?: number | null;
  includeInactive?: boolean;
  search?: string;
}

@Injectable({
  providedIn: 'root'
})
export class DriverService {
  private apiUrl = `${environment.apiUrl}/drivers`;

  constructor(private http: HttpClient) {}

  getDrivers(filter?: DriverListFilter): Observable<Driver[]> {
    let params = new HttpParams();

    if (filter?.organisationId) {
      params = params.set('organisationId', String(filter.organisationId));
    }

    if (filter?.includeInactive) {
      params = params.set('includeInactive', 'true');
    }

    if (filter?.search?.trim()) {
      params = params.set('search', filter.search.trim());
    }

    return this.http.get<unknown>(this.apiUrl, { params }).pipe(
      map(response => normalizeApiArray<Driver>(response))
    );
  }

  getDriver(id: number): Observable<Driver> {
    return this.http.get<Driver>(`${this.apiUrl}/${id}`);
  }

  createDriver(payload: DriverPayload): Observable<Driver> {
    return this.http.post<Driver>(this.apiUrl, payload);
  }

  updateDriver(id: number, payload: DriverPayload): Observable<Driver> {
    return this.http.put<Driver>(`${this.apiUrl}/${id}`, payload);
  }

  deactivateDriver(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  linkPassengerProfile(driverId: number, passengerProfileId: number): Observable<Driver> {
    return this.http.post<Driver>(`${this.apiUrl}/${driverId}/link-passenger-profile/${passengerProfileId}`, {});
  }

  createFromPassengerProfile(passengerProfileId: number, payload: DriverFromPassengerProfilePayload): Observable<Driver> {
    return this.http.post<Driver>(`${this.apiUrl}/from-passenger-profile/${passengerProfileId}`, payload);
  }
}
